import React, { useState, useEffect } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import TimePicker from "react-bootstrap-time-picker";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";

const BranchMaster = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const initialData = {
    Code: "",
    Name: "",
    Description: "",
    Address: "",
    ServiceCenterAddress: "",
    AddressCode: "",
    BranchMastersCode: "",
    BranchTXNCode: "",
    MobileNo1: "",
    MobileNo2: "",
    PhoneNo1: "",
    PhoneNo2: "",
    FaxNo: "",
    Email: "",
    Email_account: "",
    Website: "",
    CIN: "",
    PAN: "",
    TAN: "",
    MVAT: "",
    CST: "",
    ServiceTaxNo: "",
    LBT: "",
    GSTNo: "",
    StartDate: new Date(),
    ClosedDate: new Date(),
    GSTEffectiveDate: new Date(),
    StartTime: "",
    EndTime: "",
    CityID: "",
    StateID: "",
    CountryID: "",
    ZipCode: "",
    DefaultVoucherType_136: "",
    ApplicableVoucherType_136: null,
    StoreManagerID: null,
    MasterTextAppendPosition_034: "",
    TXNTextAppendPosition_034: "",
    BranchType_051: null,
  };

  const [formData, setFormData] = useState(initialData);
  const [defaultoption, setDefaultOption] = useState([]);
  const [default1, setDefault1] = useState([]);
  const [storeManagerOpt, setStoreManagerOpt] = useState([]);
  const [masterTXNA, setMasterTXNA] = useState([]);
  const [txtTextAppend, settxtAppend] = useState([]);
  const [branchtyOpt, setbranchtyOpt] = useState([]);
  const [area, setArea] = useState([]);

  // code for option type
  const handleInputChange = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  };

  // code for normal input section and customdatepicker
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // fetch option using API
  const fetchTypeOptions = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-branch-master-dropdown`
      );
      // default and applicable voucher option
      const voucherType = response.data.default_voucher;
      const options = voucherType.map((voucher) => ({
        value: voucher.value,
        label: voucher.text,
      }));
      setDefaultOption(options);
      setDefault1(options);

      // store manager option
      const storeManager = response.data.store_manager;
      const manager = storeManager.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setStoreManagerOpt(manager);

      // master and TXN Append Option
      const masterTXN = response.data.txn_text_append_position;
      const mastxn = masterTXN.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setMasterTXNA(mastxn);
      settxtAppend(mastxn);

      // Branch Type
      const BranchType = response.data.branch_type;
      const branch = BranchType.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setbranchtyOpt(branch);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };
  useEffect(() => {
    fetchTypeOptions();
  }, []);

  const areaOptions = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-company-master-dropdown`
      );
      // area details
      const area = response.data.area;
      const areaoption = area.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setArea(areaoption);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  useEffect(() => {
    areaOptions();
  }, []);

  const handleTimeChange = (name, timeInSeconds) => {
    console.log(`timeInSeconds is here`);
    console.log(timeInSeconds);
    const hours = String(Math.floor(timeInSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timeInSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const formattedTime = `${hours}:${minutes}:00`;
    setFormData({ ...formData, [name]: formattedTime });
  };

  const handleSelectChange = (selectedOption) => {
    console.log(`Selected: ${selectedOption.value}`);

    // Define the payload to send to the API
    const payload = {
      area_id: selectedOption.value,
    };

    // Make the POST request
    PostServiceCaller(`${API_URL}fetch-area-details`, payload, "post")
      .then((response) => {
        console.log("Data sent successfully:", response.data);
        const data = response.data.data;
        setFormData({
          ...formData,
          CityID: { label: data.City, value: data.CityID },
          CountryID: { label: data.Country, value: data.CountryID },
          StateID: { label: data.state, value: data.StateID },
          AreaID: { label: selectedOption.label, value: selectedOption.value },
          ZipCode: data.ZipCode,
        });
        console.log(`form data is here`);
        console.log(formData);
      })
      .catch((error) => {
        console.error("There was an error sending the data:", error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { CityID, StateID, CountryID, AreaID } = formData;

    const submitData = {
      ...formData,
      CityID: CityID ? CityID.value : "",
      StateID: StateID ? StateID.value : "",
      CountryID: CountryID ? CountryID.value : "",
      AreaID: AreaID ? AreaID.value : "",
    };

    console.log("Check Submit data", submitData);

    PostServiceCaller(`${API_URL}branch`, submitData, "post")
      .then((response) => {
        toast.success("Form submitted successfully!");
        console.log("Form submitted successfully", response);
        setTimeout(() => {
          navigate("/branchmastertable");
        }, 2000);
      })
      .catch((error) => {
        toast.error("Form Not Submitted!");
        console.error("There was an error submitting the form!", error);
      });
  };

  return (
    <>
      <div className="Container" id="form-input-section">
        <form id="formOne" className="rounded bg-white">
          <div className="row p-2">
            <div className="col-md-12">
              <div className="row">
                <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      style={{ color: "#2F2E4B" }}
                      id="genCategory-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#genCategory"
                      type="button"
                      role="tab"
                      aria-controls="genCategory"
                      aria-selected="true"
                    >
                      General Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="addDetails-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#addDetails"
                      type="button"
                      role="tab"
                      aria-controls="addDetails"
                      aria-selected="false"
                    >
                      Additional Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="areaDetails-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#areaDetails"
                      type="button"
                      role="tab"
                      aria-controls="areaDetails"
                      aria-selected="false"
                    >
                      Area Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="branchsetting-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#branchsetting"
                      type="button"
                      role="tab"
                      aria-controls="branchsetting"
                      aria-selected="false"
                    >
                      Branches Code Settings
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="comm-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#comm"
                      type="button"
                      role="tab"
                      aria-controls="comm"
                      aria-selected="false"
                    >
                      Communication Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="tax-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tax"
                      type="button"
                      role="tab"
                      aria-controls="tax"
                      aria-selected="false"
                    >
                      Tax Details
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  {/** Main Form Code start */}
                  <div
                    className="tab-pane fade show active"
                    id="genCategory"
                    role="tabpanel"
                    aria-labelledby="genCategory-tab"
                  >
                    <div class="row">
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Code</strong>
                          </label>
                          <input
                            type="text"
                            name="Code"
                            placeholder="Code"
                            className="form-control"
                            value={formData.Code}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Name</strong>
                          </label>
                          <input
                            type="text"
                            name="Name"
                            value={formData.Name}
                            onChange={handleChange}
                            placeholder="Name"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Description</strong>
                          </label>
                          <textarea
                            type="text"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={handleChange}
                            className="form-control"
                            id="Description"
                            name="Description"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Company</strong>
                          </label>
                          <input
                            type="text"
                            placeholder="Company List"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Start Date</strong>
                          </label>
                          <CustomDatePicker
                            name="StartDate"
                            handleChange={handleChange}
                            value={formData.StartDate}
                            placeholderText="Start Date"
                          ></CustomDatePicker>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Close Date</strong>
                          </label>
                          <CustomDatePicker
                            name="ClosedDate"
                            handleChange={handleChange}
                            value={formData.ClosedDate}
                            placeholderText="Close Date"
                          ></CustomDatePicker>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Start Time</strong>
                          </label>
                          <TimePicker
                            value={
                              formData.StartTime
                                ? parseInt(formData.StartTime.split(":")[0]) *
                                    3600 +
                                  parseInt(formData.StartTime.split(":")[1]) *
                                    60
                                : 0
                            }
                            start="07:00"
                            end="23:00"
                            step={30}
                            onChange={(time) =>
                              handleTimeChange("StartTime", time)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>End Time</strong>
                          </label>
                          <TimePicker
                            value={
                              formData.EndTime
                                ? parseInt(formData?.EndTime.split(":")[0]) *
                                    3600 +
                                  parseInt(formData?.StartTime.split(":")[1]) *
                                    60
                                : 0
                            }
                            start="07:00"
                            end="23:00"
                            step={30}
                            onChange={(time) =>
                              handleTimeChange("EndTime", time)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade show p-2"
                    id="addDetails"
                    role="tabpanel"
                    aria-labelledby="addDetails-tab"
                  >
                    <div className="row">
                      <div className="col-md-2">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>Default Voucher Type</strong>
                          </label>
                          <Select
                            value={formData.DefaultVoucherType_136}
                            options={default1}
                            name="DefaultVoucherType_136"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "DefaultVoucherType_136",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>Applicable Voucher Type</strong>
                          </label>
                          <Select
                            value={formData.ApplicableVoucherType_136}
                            options={defaultoption}
                            name="ApplicableVoucherType_136"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "ApplicableVoucherType_136",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div>
                          <label className="col-form-label lbl me-3">
                            <strong>Store Manager</strong>
                          </label>
                          <Select
                            value={formData.StoreManagerID}
                            options={storeManagerOpt}
                            name="StoreManagerID"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "StoreManagerID",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade show p-2"
                    id="areaDetails"
                    role="tabpanel"
                    aria-labelledby="areaDetails-tab"
                  >
                    <div class="row">
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Address</strong>
                          </label>
                          <textarea
                            type="text"
                            name="Address"
                            onChange={handleChange}
                            value={formData.Address}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Address Code</strong>
                          </label>
                          <input
                            type="text"
                            name="AddressCode"
                            value={formData.AddressCode}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Service Center Address</strong>
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={formData.ServiceCenterAddress}
                            onChange={handleChange}
                            id="ServiceCenterAddress"
                            name="ServiceCenterAddress"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>Area</strong>
                          </label>
                          <Select
                            options={area}
                            onChange={handleSelectChange}
                            value={formData.AreaID}
                            name="AreaID"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>City</strong>
                          </label>
                          <input
                            type="text"
                            name="CityID"
                            onChange={handleChange}
                            className="form-control"
                            placeholder="City"
                            value={formData.CityID?.label || ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>State</strong>
                          </label>
                          <input
                            type="text"
                            name="StateID"
                            className="form-control"
                            placeholder="State"
                            value={formData.StateID?.label || ""}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Country</strong>
                          </label>
                          <input
                            type="text"
                            name="CountryID"
                            className="form-control"
                            placeholder="Country"
                            value={formData.CountryID?.label || ""}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Zip Code</strong>
                          </label>
                          <input
                            type="text"
                            name="ZipCode"
                            className="form-control"
                            placeholder="Zip Code"
                            value={formData.ZipCode}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade show p-2"
                    id="branchsetting"
                    role="tabpanel"
                    aria-labelledby="branchsetting-tab"
                  >
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Branch Masters Code</strong>
                          </label>
                          <input
                            type="text"
                            name="BranchMastersCode"
                            value={formData.BranchMastersCode}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>Master Text Append Position</strong>
                          </label>
                          <Select
                            value={formData.MasterTextAppendPosition_034}
                            options={masterTXNA}
                            name="MasterTextAppendPosition_034"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "MasterTextAppendPosition_034",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Branch TXN Code</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            value={formData.BranchTXNCode}
                            id="BranchTXNCode"
                            name="BranchTXNCode"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>TXN Text Append Position</strong>
                          </label>
                          <Select
                            value={formData.TXNTextAppendPosition_034}
                            options={masterTXNA}
                            name="TXNTextAppendPosition_034"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "TXNTextAppendPosition_034",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div>
                          <label className="col-form-label lbl me-2">
                            <strong>Branch Type</strong>
                          </label>
                          <Select
                            value={formData.BranchType_051}
                            options={branchtyOpt}
                            name="BranchType_051"
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "BranchType_051",
                                selectedOption
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade show p-2"
                    id="comm"
                    role="tabpanel"
                    aria-labelledby="comm-tab"
                  >
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Mobile #1</strong>
                          </label>
                          <input
                            type="number"
                            name="MobileNo1"
                            value={formData.MobileNo1}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Mobile #2</strong>
                          </label>
                          <input
                            type="number"
                            value={formData.MobileNo2}
                            onChange={handleChange}
                            name="MobileNo2"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Phone #1</strong>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.PhoneNo1}
                            onChange={handleChange}
                            id="PhoneNo1"
                            name="PhoneNo1"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Phone #2</strong>
                          </label>
                          <input
                            type="number"
                            name="PhoneNo2"
                            onChange={handleChange}
                            value={formData.PhoneNo2}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Fax No.</strong>
                          </label>
                          <input
                            type="number"
                            name="FaxNo"
                            onChange={handleChange}
                            value={formData.FaxNo}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Email</strong>
                          </label>
                          <input
                            type="email"
                            name="Email"
                            onChange={handleChange}
                            value={formData.Email}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Email(Account)</strong>
                          </label>
                          <input
                            type="text"
                            name="Email_account"
                            onChange={handleChange}
                            value={formData.Email_account}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>Website</strong>
                          </label>
                          <input
                            type="text"
                            name="Website"
                            onChange={handleChange}
                            value={formData.Website}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade show p-2"
                    id="tax"
                    role="tabpanel"
                    aria-labelledby="tax-tab"
                  >
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>CIN</strong>
                          </label>
                          <input
                            type="text"
                            name="CIN"
                            onChange={handleChange}
                            value={formData.CIN}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>PAN</strong>
                          </label>
                          <input
                            type="text"
                            name="PAN"
                            onChange={handleChange}
                            value={formData.PAN}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label className="col-form-label lbl me-3">
                            <strong>TAN</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange}
                            value={formData.TAN}
                            name="TAN"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>GSTIN/UIN</strong>
                          </label>
                          <input
                            type="text"
                            name="GSTNo"
                            onChange={handleChange}
                            value={formData.GSTNo}
                            className="form-control"
                          />
                        </div>
                      </div>
                      </div>
                      <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>GST Date</strong>
                          </label>
                          <CustomDatePicker
                            name="GSTEffectiveDate"
                            handleChange={handleChange}
                            value={formData.GSTEffectiveDate}
                            placeholderText="GST Date"
                          ></CustomDatePicker>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>VAT/TIN</strong>
                          </label>
                          <input
                            type="text"
                            name="MVAT"
                            onChange={handleChange}
                            value={formData.MVAT}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>CST</strong>
                          </label>
                          <input
                            type="text"
                            name="CST"
                            onChange={handleChange}
                            value={formData.CST}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>Service Tax No.</strong>
                          </label>
                          <input
                            type="text"
                            name="ServiceTaxNo"
                            onChange={handleChange}
                            value={formData.ServiceTaxNo}
                            className="form-control"
                          />
                        </div>
                      </div>
                      </div>
                      <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>LBT</strong>
                          </label>
                          <input
                            type="text"
                            name="LBT"
                            onChange={handleChange}
                            value={formData.LBT}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label lbl me-2">
                            <strong>PTRC</strong>
                          </label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-end mt-2 me-3">
            <Link to="/branchmastertable" className="cancel-btn me-2">
              Cancel
            </Link>
            <button type="submit" className="custom-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default BranchMaster;
